<template>
  <div v-if="paymentDetail && languageCode">
    <div class="row mt-3">
      <div class="col-md-12 content-list mb-2">
        <b>Payment Provider:</b>
        <span>{{ paymentDetail.paymentGateway }}</span>
      </div>

      <div
        v-if="paymentDetail.paymentMethod"
        class="col-md-12 content-list mb-2"
      >
        <b>Payment Method:</b>
        <span>{{ paymentDetail.paymentMethod }}</span>
      </div>

      <div
        v-if="paymentDetail.cardNumber"
        class="col-md-12 content-list mb-2"
      >
        <b>Card Number:</b>
        <span>{{ paymentDetail.cardNumber }}</span>
      </div>

      <div
        v-if="paymentDetail.cardType"
        class="col-md-12 content-list mb-2"
      >
        <b>Card Type:</b>
        <span>{{ paymentDetail.cardType }}</span>
      </div>
      <div
        v-if="paymentDetail.expiryDate"
        class="col-md-12 content-list mb-2"
      >
        <b>Card Expiry:</b>
        <span>{{ paymentDetail.expiryDate }}</span>
      </div>
    </div>

    <span v-if="paymentHistory">
      <div class="payment-history-title">Payment History</div>

      <div class="table-responsive">
        <table class="table table-striped table-bordered">
          <thead>
            <tr>
              <th>Date</th>
              <th>Action</th>
              <th>Amount</th>
              <th>Refunded By</th>
              <th>Refund Reason/Error</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(payment, index) in orderedPaymentHistory"
              :key="index"
            >
              <td>{{ localDateTime(payment.date) | formatDate }}</td>
              <td>{{ payment.action | splitPascal }}</td>
              <td>{{ $n(payment.amount , 'currency', languageCode) }}</td>
              <td>{{ payment.refundedByUserName }}</td>
              <td v-if="payment.refundDetails">{{ payment.refundDetails }}</td>
              <td v-else>{{ payment.errorMessage }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </span>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import moment from 'moment'
export default {
    name: 'PaymentDetails',
    computed: {
        ...mapState({
            paymentDetail: state => state.booking.paymentDetail,
            paymentHistory: state => state.booking.paymentHistory,
            languageCode () {
                return this.$store.getters['getLanguageCode']({
                    identifier: this.$store.state.airport.selectedAirportId
                })
            }
        }),
        ...mapGetters(['getSelectedAirportTimeZone']),
        orderedPaymentHistory () {
            let paymentHistory = Array.from(this.paymentHistory)
            return paymentHistory.sort((a, b) => new Date(b.date) - new Date(a.date))
        }
    },
    created: function () {
        this.$store.dispatch('getPaymentDetail', this.$route.params.bookingId)
        this.$store.dispatch('getPaymentHistory', this.$route.params.bookingId)
    },
    methods: {
        localDateTime (dateTime) {
            var utcDateTime = moment.utc(dateTime.slice(0, 16))
            var localDateTime = utcDateTime.tz(this.getSelectedAirportTimeZone).format('DD MMM YYYY HH:mm')
            return localDateTime
        }
    }
}
</script>

<style lang="scss" scoped>

.payment-history-title {
    color: #032f61;
    font-weight: 600;
    padding: 10px 0 10px 0;
    font-size: 14px;

    @media (min-width: 1200px) {
        font-size: 16px;
    }
}

</style>
